import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

export enum StatusDTO {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface AchRelationshipDTO {
  id: string;
  name: string;
  status: StatusDTO;
  institutionName: string;
  rejectionReasons: string[];
}

const fetchAchRelationships = async (
  clientId: string,
  managedAccountId: string,
): Promise<AchRelationshipDTO[]> => {
  return authFetch(
    urlWithParams('/Consumer/AchRelationships', {
      clientId,
      managedAccountId,
    }),
  );
};

export const useAchRelationshipsQuery = () => {
  const { clientId, managedAccountId } = useTransferMoneyContext();

  return useQuery(
    queryKeys.achRelationships(clientId, managedAccountId),

    () => fetchAchRelationships(clientId, managedAccountId),

    {
      cacheTime: 0,
    },
  );
};
